import Image from 'app/Components/Shared/Image/image';
import './SelfCareHeader.scss';
import {Swiper, SwiperSlide} from 'swiper/react';
import PopUp from '../../../../Shared/Popup/PopUp';
// import 'swiper/css';
import React, {useState, useEffect, useLayoutEffect} from 'react';
import CircularSwiperMobile from './CircularSwiperMobile';
import TrackerExpanded from '../header/tracker/trackerExpanded';
import Tracker from '../header/tracker/tracker';
import {isMobile} from 'react-device-detect';
import CircularSwiperDesktop from './CircularSwiperDesktop';
import Config from 'app/Config';
import {connect} from 'react-redux';
import {
  displayPopUp,
  setWorldType,
  setEpiData,
  setClickedActionUrl,
  setSubscribersAbroadTabShown,
  closePopUpOnTrackerInit,
} from '../../SelfCareSlice';
import {internalPage, TAB_ENUM, worldEnum} from '../../Constant';
import {checkLoginData} from '../../Utilities';
import {handleURL, prepareUrl, buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import WelcomeUserText from './welcomeUserText';
import {hideAppLoader} from '../../../../Shared/Loader/LoaderSlice';
import IdValidationPopup from '../../../../../Components/Block/OTPLoginBlock/Popups/idValidationPopup';
import TrackerInitPopup from './tracker/TrackerInitPopUp';
import {setShowMenu} from '../../../../Block/HeaderMainBlock/HeaderBlockSlice';
import {dwhViewMainLobby, dwhViewNonExistentProductLobby, dwhViewServices} from './dwhReports';

function SelfCareHeader(props) {
  const isEcellcomFlagOn = props.startPage.isShowEcellcom.value ?? false;
  const isUserConnected = checkLoginData(props.authentication.loginData);
  const [showIDPopup, setShowIDPopUp] = useState(false);
  const [isEcellcomFlagOnAndUserDoesNotHaveCell, setIsEcellcomFlagOnAndUserDoesNotHaveCell] = useState(false);
  let currentPage = props.selfCareSlice?.epiData?.worldType;
  let clickedActionUrl = '';

  const epiBaseUrl = Config?.epiBaseUrl;
  const EPI_TABS = props.startPage.selfCareTabs.expandedValue;

  const TABS_IN_ORIGINAL_ORDER_FROM_EPI = Array.from({length: Object.keys(EPI_TABS).length}, (_, i) => ({
    id: EPI_TABS[i].tabId?.value.toLowerCase(),
    tabTitle: EPI_TABS[i].mainTitle?.value ?? '',
    tabSubTitle: '',
    worldLink: EPI_TABS[i].link.value,
    backgroundImageDesktop: EPI_TABS[i].backgroundImageDesktop?.value?.url ?? '',
    backgroundImageMobile: EPI_TABS[i].backgroundImageMobile?.value?.url ?? '',
    isShowBadge: EPI_TABS[i]?.isShowBadge?.value ?? false,
    badgeImg: EPI_TABS[i]?.badgeIcon?.value ?? null,
    tabData: false,
    isTabVisible: EPI_TABS[i]?.isTabVisible?.value ?? true,
  })).filter((tab) => tab.isTabVisible);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [userProductsAndServices, setUserProductsAndServices] = useState(null);
  const [isTabDataReady, setIsTabDataReady] = useState(false);

  if (!isUserConnected) {
    return null; // Render nothing while checking authentication
  }
  function checkUserAvailableServices(userProductsAndServices) {
    if (userProductsAndServices !== null && userProductsAndServices !== undefined) {
      return userProductsAndServices[currentPage.toLowerCase()];
    }
  }

  useEffect(() => {
    const userDetails = props.authentication.loginData.userDetails;
    const fullName = userDetails.firstName + ' ' + userDetails.lastName;
    const idNumber = userDetails.IDNumber;
    const subscriber = userDetails.contactNumber;
    const ban = userDetails.Ban;
    switch (currentPage) {
      case TAB_ENUM.Main:
        dwhViewMainLobby(fullName, subscriber, idNumber, ban);
        break;

      default:
        if (checkUserAvailableServices(userProductsAndServices)) {
          dwhViewServices(fullName, subscriber, idNumber, ban, null, null, currentPage);
        } else {
          dwhViewNonExistentProductLobby(fullName, subscriber, idNumber, ban, null, null, currentPage);
        }
        break;
    }
  }, [currentPage]);

  useEffect(() => {
    getUserProductAndServices();
    if (userProductsAndServices) {
      addTabData(TABS_IN_ORIGINAL_ORDER_FROM_EPI);
    }
    if (isEcellcomFlagOn) {
      const keys = Object.keys(props.selfCareSlice.subscribersByProduct);
      if (!keys.includes(TAB_ENUM.Cellular)) {
        setIsEcellcomFlagOnAndUserDoesNotHaveCell(true);
      } else {
        setIsEcellcomFlagOnAndUserDoesNotHaveCell(false);
      }
    }
    props.setEpiData(props.startPage);
  }, [props.selfCareSlice.isFetchLoginData]);

  function getImageUrl() {
    if (TABS_IN_ORIGINAL_ORDER_FROM_EPI != null) {
      if (isMobile) {
        return epiBaseUrl + TABS_IN_ORIGINAL_ORDER_FROM_EPI[selectedIndex]?.backgroundImageMobile;
      } else {
        return epiBaseUrl + TABS_IN_ORIGINAL_ORDER_FROM_EPI[selectedIndex]?.backgroundImageDesktop;
      }
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function getUserProductAndServices() {
    const keys = Object.keys(props.selfCareSlice.subscribersByProduct);
    const userProductsAndServices = {
      cellular: false,
      tv: false,
      abroad: false,
      energy: false,
      internet: false,
    };

    // Check if the keys exist in the object and update the corresponding properties
    keys.forEach((key) => {
      if (key.toLowerCase().includes(TAB_ENUM.Cellular.toLowerCase())) {
        userProductsAndServices.cellular = true;
      } else if (key.toLowerCase().includes(TAB_ENUM.TV.toLowerCase())) {
        userProductsAndServices.tv = true;
      } else if (key.toLowerCase().includes(TAB_ENUM.Abroad.toLowerCase())) {
        userProductsAndServices.abroad = true;
      } else if (key.toLowerCase().includes(TAB_ENUM.Energy.toLowerCase())) {
        userProductsAndServices.energy = true;
      } else if (key.toLowerCase().includes(TAB_ENUM.Internet.toLowerCase())) {
        userProductsAndServices.internet = true;
      }
    });
    setUserProductsAndServices(userProductsAndServices);
  }
  useEffect(() => {
    if (props.selfCareSlice.subscribersAbroad && !props.selfCareSlice.subscribersAbroadTabShown) {
      props.setSubscribersAbroadTabShown(true);
      prepareUrl(EPI_TABS[worldEnum.Abroad].link.value, props.context);
    }
  }, [props.selfCareSlice.subscribersAbroad]);

  function handleSelectedIndex(swiper, arr) {
    // const url = window.location.pathname;
    // const lastSegment = url.split('/').filter(Boolean).pop();
    // if (lastSegment) {
    // const matchingTab = arr.find((tab) => tab.id.toLowerCase() === lastSegment.toLowerCase()); // TAKE THE CURRENT PAGE FROM PATH
    let matchingTab;
    matchingTab = arr.find((tab) => tab.id.toLowerCase() === currentPage.toLowerCase()); // TAKE THE CURRENT PAGE FROM SLICE
    const matchingTabIndex = arr.indexOf(matchingTab);
    setActiveIndex(matchingTabIndex);
    setSelectedIndex(matchingTabIndex);
    if (swiper && swiper.slides) {
      swiper.slideTo(matchingTabIndex, 0);
    }
    // }
  }
  function reorderTabs(tabs, availability) {
    if (tabs != null && availability != null) {
      if (isEcellcomFlagOnAndUserDoesNotHaveCell) {
        availability[TAB_ENUM.Abroad.toLowerCase()] = true;
      }
      const availableTabs = tabs.filter((tab) => availability[tab.id]);
      const unavailableTabs = tabs.filter((tab) => !availability[tab.id]);

      const mainTab = unavailableTabs.find((tab) => tab.id === TAB_ENUM.Main.toLowerCase());
      if (mainTab) {
        availableTabs.unshift(mainTab);
      }

      const unavailableTabsWithoutMain = unavailableTabs.filter((tab) => tab.id !== TAB_ENUM.Main.toLowerCase());

      return [...availableTabs, ...unavailableTabsWithoutMain];
    }
  }
  function addTabData(tabs) {
    const productsAndServices = props.selfCareSlice.subscribersByProduct;
    const keys = Object.keys(productsAndServices);
    const TabsWithData = [];
    keys.forEach((key) => {
      const originalTab = tabs.find((tab) => tab.id.toLowerCase() === key.toLowerCase());
      const index = tabs.indexOf(originalTab);
      const tabData = productsAndServices[key];
      if (index !== -1) {
        tabs[index] = {...originalTab, tabData: tabData};
        tabs[index].tabSubTitle = getTabSubTitle(tabs[index], key, tabData);
      }
    });
    if (isEcellcomFlagOnAndUserDoesNotHaveCell) {
      const originalTab = tabs.find((tab) => tab.id.toLowerCase() === TAB_ENUM.Abroad.toLowerCase());
      tabs[tabs.findIndex((tab) => tab.id.toLowerCase() === TAB_ENUM.Abroad.toLowerCase())] = {...originalTab, tabData: true};
    }
    return tabs;
  }

  function getTabSubTitle(tab, key, data) {
    if (key.toLowerCase() === TAB_ENUM.Cellular.toLowerCase()) {
      const numberOfConsumers = data.length;
      if (numberOfConsumers > 1) {
        return `${numberOfConsumers} מנויים`;
      } else {
        return data[0].productSubscriberNo;
      }
    }
    if (key.toLowerCase() === TAB_ENUM.Energy.toLowerCase()) {
      const numberOfConsumers = data.length;
      if (numberOfConsumers > 1) {
        return `${numberOfConsumers} מנויים`;
      } else {
        return '';
      }
    }
    if (key.toLowerCase() === TAB_ENUM.Internet.toLowerCase()) {
      if (props.selfCareSlice.isFetchData) {
        const numberOfConsumers = data.length;
        if (numberOfConsumers > 1) {
          return `${numberOfConsumers} מנויים`;
        } else {
          const internetObject = props.selfCareSlice?.subscribersByProduct['Internet'];
          const downloadSpeed = internetObject[0]?.downloadSpeed;
          if (downloadSpeed) {
            return ``;
            // return `עד ${downloadSpeed ?? ""} MB`;
          } else {
            return '';
          }
        }
      }
    }
  }
  const TABS_IN_ORIGINAL_ORDER_AFTER_PRODUCT_AND_SERVICES = props.isFetchLoginData ? addTabData(TABS_IN_ORIGINAL_ORDER_FROM_EPI) : null;
  const reorderedTabs = props.isFetchLoginData
    ? reorderTabs(TABS_IN_ORIGINAL_ORDER_AFTER_PRODUCT_AND_SERVICES, userProductsAndServices)
    : null;

  const CloseModal = () => {
    props.displayPopUp(false);
  };

  const closeModalIdPopup = () => {
    setShowIDPopUp(false);
    props.hideAppLoader();
    navigateToPage(props?.selfCareSlice?.selfCareData?.trackers?.clickedActionUrl);
  };

  const navigateToPage = (url) => {
    handleURL(url, props.context);
  };

  const handleIdPopup = (url) => {
    if (props.authentication.loginData.isFullAuthenticated) {
      navigateToPage(url);
    } else {
      props.setClickedActionUrl(url);
      setShowIDPopUp(true);
    }
  };

  const handleBackgroundImage = () => {
    if (
      props?.selfCareSlice?.mainCustomerInfoCellular?.isBusiness &&
      props?.selfCareSlice?.mainCustomerInfoCellular?.orgId == props?.selfCareSlice?.orgId
    ) {
      let organizationData = props.selfCareSlice.organizationState;
      let urlPart;
      switch (selectedIndex) {
        case 0:
          urlPart = isMobile
            ? organizationData?.organizationMainMobileImage?.value?.url
            : organizationData?.organizationMainDesktopImage?.value?.url;
          break;
        case 2:
          urlPart = isMobile
            ? organizationData?.organizationAbroadMobileImage?.value?.url
            : organizationData?.organizationAbroadDesktopImage?.value?.url;
          break;
        case 1:
          urlPart = isMobile
            ? organizationData?.organizationCellularMobileImage?.value?.url
            : organizationData?.organizationCellularDesktopImage?.value?.url;
          break;
        default:
      }
      if (urlPart) {
        return epiBaseUrl + urlPart;
      }
    }
    return !isMobile
      ? epiBaseUrl + TABS_IN_ORIGINAL_ORDER_FROM_EPI[selectedIndex]?.backgroundImageDesktop
      : reorderedTabs != null
      ? epiBaseUrl + reorderedTabs[selectedIndex]?.backgroundImageMobile
      : null;
  };

  return (
    <div className={`self-care-header ${props.page != internalPage.Main ? 'd-none' : ''}`}>
      <div style={{width: '100%', height: '600px', overflow: 'hidden', position: 'absolute', textAlign: 'center'}}>
        <Image style={{
            position: 'absolute',
            width: isMobile ? '100%' : 'unset',
            height: isMobile ? '350px' : '600px',
            transform: 'translate(50%, 0)',
          }}
          src={handleBackgroundImage()} />
      </div>
      <div className='swiper-main-container'>
        <div className='tracker-swiper-container'>
          {isMobile && props.selfCareSlice.selfCareData.trackers.showPopUp && (
            <TrackerExpanded
              popUpType={props.selfCareSlice.selfCareData.trackers.popUpType}
              {...props.selfCareSlice.selfCareData.trackers.popUpProps}
              context={props.context}
              urlToAbroad={props.startPage.selfCareTracker.expandedValue[0].pageRefToMyAbroadPackage.value}
              navigateToPage={navigateToPage}
              contentData={props.startPage.selfCareTracker.expandedValue[0]}
              closePage={CloseModal}
              handleIdPopup={buildUrlAndOpenSameWindow}
            />
          )}
          {!isMobile && (
            <PopUp onClose={CloseModal} showPopUp={props.selfCareSlice.selfCareData.trackers.showPopUp}>
              <TrackerExpanded
                popUpType={props.selfCareSlice.selfCareData.trackers.popUpType}
                {...props.selfCareSlice.selfCareData.trackers.popUpProps}
                context={props.context}
                urlToAbroad={props.startPage.selfCareTracker.expandedValue[0].pageRefToMyAbroadPackage.value}
                navigateToPage={navigateToPage}
                contentData={props.startPage.selfCareTracker.expandedValue[0]}
                closePage={CloseModal}
                handleIdPopup={buildUrlAndOpenSameWindow}
              />
            </PopUp>
          )}
          <div className='user-info-container' style={{minHeight: '100px'}}>
            {currentPage === 'Main' && props.showTracker && (
              <div className='tracker-main-wrapper'>
                <Tracker epiData={props.startPage.selfCareTracker.expandedValue[0]} context={props.context} />
              </div>
            )}
          </div>
        </div>
        {currentPage === 'Main' && (
          <WelcomeUserText
            subHeader={props.startPage?.selfCareWelcomeUser?.expandedValue[0].subHeader?.value}
            noNameText={props.startPage?.selfCareWelcomeUser?.expandedValue[0].noNameText?.value}
          />
        )}
        <div className={`circular-swiper-wrapper ${selectedIndex == 0 ? 'first-slide' : ''}`}>
          {isMobile ? (
            <CircularSwiperMobile
              arr={reorderedTabs}
              currentPage={currentPage}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              selectedIndex={selectedIndex}
              setSelectedIndex={setSelectedIndex}
              handleSelectedIndex={handleSelectedIndex}
              epiBaseUrl={epiBaseUrl}
              isFetchLoginData={props.isFetchLoginData}
              context={props.context}></CircularSwiperMobile>
          ) : (
            <CircularSwiperDesktop
              currentPage={currentPage}
              arr={TABS_IN_ORIGINAL_ORDER_AFTER_PRODUCT_AND_SERVICES}
              activeIndex={activeIndex}
              handleSelectedIndex={handleSelectedIndex}
              setActiveIndex={setActiveIndex}
              selectedIndex={selectedIndex}
              setSelectedIndex={setSelectedIndex}
              epiBaseUrl={epiBaseUrl}
              isFetchLoginData={props.isFetchLoginData}
              context={props.context}></CircularSwiperDesktop>
          )}
        </div>
      </div>
      <PopUp showPopUp={showIDPopup} className='idValidationPopup' onClose={() => setShowIDPopUp(false)} style={{background: 'white'}}>
        <IdValidationPopup setShowPopUp={setShowIDPopUp} closeModal={closeModalIdPopup} />
      </PopUp>
      <PopUp
        showPopUp={props.selfCareSlice.selfCareData.showPopUpOnTrackerInit}
        className='tracker-init-popup'
        onClose={() => props.closePopUpOnTrackerInit()}>
        <TrackerInitPopup epiData={props.startPage} />
      </PopUp>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    selfCareSlice: state.selfcarePage,
    page: state.selfcarePage?.page,
    isFetchLoginData: state.selfcarePage?.isFetchLoginData,
    showTracker: state.selfcarePage.selfCareData.trackers.requestSuccessfullyCompleted,
  };
};

const mapDispatchToProps = {
  displayPopUp,
  setWorldType,
  setEpiData,
  hideAppLoader,
  setClickedActionUrl,
  setSubscribersAbroadTabShown,
  closePopUpOnTrackerInit,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfCareHeader);
